import { ReactElement } from 'react';

import { useBoolean } from '@dreryk/react-common';

import { WaitlistEntryCreateModal } from './WaitlistEntryCreateModal';

type WaitlistEntryModalOpenerChildrenRenderProps = {
   openModal: VoidFunction;
};

type WaitlistEntryModalOpenerProps = {
   children: (renderProps: WaitlistEntryModalOpenerChildrenRenderProps) => ReactElement;
};

export const WaitlistEntryCreateModalOpener = (props: WaitlistEntryModalOpenerProps): ReactElement => {
   const [{ setTrue: openModal, setFalse: closeModal }, modalOpened] = useBoolean();
   return (
      <>
         {props.children({ openModal: openModal })}
         {modalOpened ? <WaitlistEntryCreateModal onClose={closeModal} /> : null}
      </>
   );
};
